// src/pages/NotFoundPage.jsx

import React from "react";
import { Result, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Sparkles } from "lucide-react";
import "./style.css";

const { Paragraph } = Typography;

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="notfound-wrapper">
      <div className="notfound-overlay" />

      <div className="floating-circle circle-1" />
      <div className="floating-circle circle-2" />
      <div className="floating-circle circle-3" />

      <Result
        status="404"
        title={
          <span className="notfound-title">
            4<Sparkles size={40} />4
          </span>
        }
        subTitle={
          <div>
            <h2 className="notfound-heading">
              Oops! Page Not Found
            </h2>

           <Paragraph className="notfound-text">
  The page you are looking for may have been moved,
  deleted. Please contact Technical team.

  <br />

  <a
    href="tel:+919766126756"
    className="support-call-link"
  >
    📞 +91 9766126756
  </a>
</Paragraph>
          </div>
        }
      />
    </div>
  );
}